import { Route, Routes } from "react-router-dom";
import { URLProtected } from "../Admin/Common";
import { AdminLogin } from "../Admin/pages/AdminLogin";
import { AdminLayout } from "../layouts/AdminLayout";
import {
  UserList,
  ManufacturerList,
  DistributorList,
} from "../Admin/pages/UsersList";
import { OrderList } from "../Admin/pages/OrderList";
import { RequestList } from "../Admin/pages/ManageRequests";
import { ViewManageRequest } from "../Admin/pages/ViewManageRequest";
import { NewEquipList, UsedEquipList } from "../Admin/pages/Eqipment";
// import { DashboardKpi } from "../Admin/pages/DahsboardKpi";
import { ScheduledMeetings } from "../Admin/pages/SheduledMeet";
import { Inspection } from "../Admin/pages/Inspection";
import { Categories } from "../Admin/pages/Categoreis";
import { Speciality } from "../Admin/pages/Speciality";
import { UserFrom } from "../Admin/pages/Forms/UserForm";
import { DistMFform } from "../Admin/pages/Forms/DistMFform";
import { EquipForm } from "../Admin/pages/Forms/EqipForm";
import { ScheduleMeetForm } from "../Admin/pages/Forms/ScheduleMeetForm";
import { InspectMeetForm } from "../Admin/pages/Forms/InspForm";
import { OrderForm } from "../Admin/pages/Forms/OrderForm";
import { AdmNotification } from "../Admin/pages/AdmNotification";
import { PaymentList } from "../Admin/pages/managePayments";
import { ViewPayment } from "../Admin/pages/ViewPayment";
import { FailedPayments } from "../Admin/pages/FailedPayments";
import { SystemPrice } from "../Admin/pages/SysPrice";
import { BlogsArticles } from "../Admin/pages/content/BlogsArticle";
import React from "react";
import { AddContentForm } from "../Admin/pages/Forms/AddContentForm";
import { ContactList } from "../Admin/pages/ContactList";
import { RequestForm } from "../Admin/pages/Forms/RequestsForm";
import { ArrangeDemoList } from "../Admin/pages/ArrangeDemo";
import { DemoView } from "../Admin/pages/DemoView";
import RequestServices from "../Admin/pages/RequestServices";
import RequestedOrder from "../Admin/pages/RequestedOrder";
import SellServices from "../Admin/pages/SellServices";
import { SparepareAssocirese } from "../Admin/pages/SparepareAssocirese";
import { RequestForServiceContact } from "../Admin/pages/RequestForServiceContact";
import Promotions from "../Admin/pages/others/Promotions";
import Departments from "../Admin/pages/others/Departments";
import BestOffers from "../Admin/pages/others/BestOffers";
import MedicalDepartment from "../Admin/pages/MedicalCategories/MedicalDepartment";
import Category from "../Admin/pages/MedicalCategories/Category";
import SubCategory from "../Admin/pages/MedicalCategories/SubCategory";
import DashboardKpi from "../Admin/pages/DahsboardKpi";
import CustomerSupport from "../Admin/pages/CustomerSupport";
import CustomerManagement from "../Admin/pages/CustomerManagement";
import ProductExtraDetails from "../Admin/pages/Forms/ProductExtraDetails";
import ActivityLogs from "../Admin/pages/ActivityLogs";
import ChangeOwnerName from "../Admin/pages/Forms/ChangeOwnerName";
import Invoice from "../Admin/pages/ActivityLogs/Invoice";
import InvoiceCustom from "../Admin/pages/ActivityLogs/InvoiceCustom";
import ChangeUrl from "../Admin/pages/ChangeUrl";
import HsnCode from "../Admin/pages/HsnCode";
import OffLineOrders from "../Admin/pages/OffLineOrders";
import UnsubscribeEmail from "../Admin/pages/UnsubscribeEmail";



import SearchData from "../Admin/pages/SearchData";
import GMC from "../Admin/pages/GMC";
import Banners from "../Admin/pages/Banners";
import TrendingProducts from "../Admin/pages/TrendingProducts";
import UserAnalytics from "../Admin/pages/UserAnalytics";
import UserAnalyticsActivity from "../Admin/pages/UserAnalyticsActivity";
import SecurePDFViewer from "../features/SecureViewer/SecurePDFViewer";
import ImageUrls from "../Admin/pages/ImageUrls";
import Tax from "../Admin/Tax";
import ProductEventCount from "../Admin/pages/ProductEventCount";


export const AdminRoute = () => {
  return (
    <Routes>
      <Route exact path="/admin/login/" element={<AdminLogin />} />

      <Route
        exact
        path="/admin/"
        element={<URLProtected component={<AdminLayout />} />}
      >
        <Route exact path="dashboard/" element={<DashboardKpi />} />

        <Route exact path="manageusers/" element={<UserList />} />
        <Route
          exact
          path="managemanufacturer/"
          element={<ManufacturerList />}
        />
        <Route exact path="managedistributor/" element={<DistributorList />} />
        <Route exact path="manageorder/" element={<OrderList />} />
        <Route exact path="managerequest/" element={<RequestList />} />
        <Route exact path="managerequest/view-manage-request/" element={<ViewManageRequest />} />
        <Route exact path="contactlist/" element={<ContactList />} />
        <Route exact path="requestforservice/" element={<RequestForServiceContact />} />
        <Route exact path="demorequests/" element={<ArrangeDemoList />} />
        <Route exact path="demorequests/demoview/" element={<DemoView />} />
        <Route exact path="managepayments/" element={<PaymentList />} />
        <Route exact path="managepayments/viewpayment/" element={<ViewPayment />} />
        <Route exact path="managepayments/failed-payments/" element={<FailedPayments />} />
        <Route exact path="managesystemprice/" element={<SystemPrice />} />
        <Route exact path="manageneweqip/" element={<NewEquipList />} />

        <Route exact path="manageusedeqip/" element={<UsedEquipList />} />
        <Route exact path="/admin/Services/" element={<SellServices />} />
        <Route exact path="/admin/sparepare/" element={<SparepareAssocirese />} />
        <Route exact path="managemeetings/" element={<ScheduledMeetings />} />
        <Route exact path="manageinspection/" element={<Inspection />} />
        <Route exact path="managecategories/" element={<Categories />} />
        <Route exact path="managespeciality/" element={<Speciality />} />
        <Route exact path="notification/" element={<AdmNotification />} />
        <Route exact path="requestServices/" element={<RequestServices />} />
        <Route exact path="requestedorders/" element={<RequestedOrder />} />
        {/* others  */}
        <Route exact path="promotions/" element={<Promotions />} />
        <Route exact path="departments/" element={<Departments />} />
        <Route exact path="best-offers/" element={<BestOffers />} />
        <Route exact path="medical-department/" element={<MedicalDepartment />} />
        <Route exact path="medical-department/categories/" element={<Category />} />
        <Route exact path="medical-department/subcategories/" element={<SubCategory />} />
        <Route exact path="customersupport/" element={<CustomerSupport />} />
        <Route exact path="customer-management/" element={<CustomerManagement />} />
        <Route exact path="change-url/" element={<ChangeUrl />} />
        <Route exact path="hsn-code/" element={<HsnCode />} />
        <Route exact path="taxs/" element={<Tax />} />
        <Route exact path="search-data/" element={<SearchData />} />
        <Route exact path="gmc/" element={<GMC />} />
        <Route exact path="add-banners/" element={<Banners />} />
        <Route exact path="trending-products/" element={<TrendingProducts />} />
        <Route exact path="user-analytics/" element={<UserAnalytics />} />
        <Route exact path="user-analytics-activity/" element={<UserAnalyticsActivity />} />
        {/* content management */}

        <Route
          exact
          path="blogs/"
          element={
            <BlogsArticles
              data={{ title: "Blogs", type: 3, addURL: "/admin/blogs/add/" }}
            />
          }
        />
        <Route
          exact
          path="blogs/add/"
          element={
            <AddContentForm
              data={{ title: "Blogs", type: 3, listURL: "/admin/blogs/" }}
            />
          }
        />

        <Route
          exact
          path="articles/"
          element={
            <BlogsArticles
              data={{
                title: "Articles",
                type: 5,
                addURL: "/admin/articles/add/",
              }}
            />
          }
        />
        <Route
          exact
          path="articles/add/"
          element={
            <AddContentForm
              data={{ title: "Articles", type: 5, listURL: "/admin/articles/" }}
            />
          }
        />

        <Route
          exact
          path="techupdates/"
          element={
            <BlogsArticles
              data={{
                title: "Tech Updates",
                type: 6,
                addURL: "/admin/techupdates/add/",
              }}
            />
          }
        />
        <Route
          exact
          path="techupdates/add/"
          element={
            <AddContentForm
              data={{
                title: "Tech Updates",
                type: 6,
                listURL: "/admin/techupdates/",
              }}
            />
          }
        />

        <Route
          exact
          path="experttips/"
          element={
            <BlogsArticles
              data={{
                title: "Expert Tips",
                type: 7,
                addURL: "/admin/experttips/add/",
              }}
            />
          }
        />
        <Route
          exact
          path="experttips/add/"
          element={
            <AddContentForm
              data={{
                title: "Expert Tips",
                type: 7,
                listURL: "/admin/experttips/",
              }}
            />
          }
        />

        {/* view users */}
        <Route exact path="manageusers/viewuser/:uid" element={<UserFrom />} />
        <Route
          exact
          path="managemanufacturer/viewuser/"
          element={<DistMFform />}
        />
        <Route exact path="manageneweqip/viewuser/" element={<EquipForm />} />
        <Route exact path="product-description/" element={<ProductExtraDetails />} />
        <Route exact path="change-owner/" element={<ChangeOwnerName />} />
        <Route
          exact
          path="managemeetings/view/"
          element={<ScheduleMeetForm />}
        />
        <Route
          exact
          path="manageinspection/view/"
          element={<InspectMeetForm />}
        />
        <Route exact path="manageorder/view/" element={<OrderForm />} />
        <Route exact path="contactlist/view/" element={<RequestForm />} />
        <Route exact path="activity-logs/" element={<ActivityLogs />} />
        <Route exact path="invoice/" element={<Invoice />} />
        <Route exact path="custom-invoice-generator/" element={<InvoiceCustom />} />
        <Route exact path="individual-coupons/" element={<OffLineOrders />} />
        <Route exact path="image-urls/" element={<ImageUrls />} />
        <Route exact path="product-event-count/" element={<ProductEventCount />} />
        <Route exact path="unsubscribed-emails/" element={<UnsubscribeEmail />} />
        <Route exact path="unsubscribed-email/" element={<UnsubscribeEmail />} />
      </Route>

      {/* Secure File Viewer - standalone route outside admin layout */}
      <Route path="/secure-viewer" element={<SecurePDFViewer />} />
    </Routes>
  );
};
